import React from 'react';
import { graphql } from 'gatsby';
import SEO from '../components/common/SEO';
import BlogPageLayout from '../components/pages/blogPage/BlogPageLayout/BlogPageLayout';

export const query = graphql`
  query MyQuery($postId: ID!, $categoryId: Int) {
    wpgraphql {
      post(id: $postId, idType: ID) {
        title
        slug
        id
        date
        author {
          node {
            name
          }
        }
        content
        featuredImage {
          node {
            altText
            mediaItemUrl
          }
        }
        categories {
          nodes {
            name
            slug
          }
        }
        templateFormat {
          templateOption
        }
      }
      posts(where: { categoryId: $categoryId }, first: 5) {
        nodes {
          date
          excerpt
          title
          slug
          id
          author {
            node {
              name
            }
          }
          content
          categories {
            nodes {
              name
              databaseId
              uri
              slug
            }
          }
          featuredImage {
            node {
              altText
              mediaItemUrl
            }
          }
          uri
        }
      }
    }
  }
`;

export default function BlogPageTemplate({ data }) {
  const post = data.wpgraphql.post;
  const { title = '', slug = '', featuredImage = {} } = post;
  return (
    <>
      <SEO
        title={title}
        description="Serving daily meals for a hunger-free India"
        image={
          featuredImage?.node?.mediaItemUrl ||
          'https://www.zomato.com/blog/wp-content/uploads/2021/07/cover-future-1024x674.png'
        }
        url={slug}
      />
      <BlogPageLayout
        blog={post}
        suggestionBlogs={data.wpgraphql.posts.nodes}
      />
    </>
  );
}
